<template>
  <div class="header-desktop-main">
    <v-app-bar class="overflow-hidden" color="#fafafa" height="96px" flat>
      <v-sheet
        class="d-flex justify-space-between align-center mx-auto"
        color="transparent"
        max-width="1194px"
        width="100%"
        height="100%"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="58px"
          />
        </router-link>

        <v-sheet height="100%" color="transparent" class="d-flex align-center">
          <div class="position-relative header-desktop-main-navigation">
            <div
              v-for="({ text, to, submenu }, key) in menu"
              :key="key"
              class="d-inline-flex"
            >
              <v-btn
                class="
                  primary--text
                  text--lighten-2 text-caption text-lg-body-1 text-none
                  px-2 px-lg-3
                  py-5
                  nav-link
                "
                :class="{ 'ml-lg-2': key > 0 }"
                :to="to"
                active-class="font-weight-bold nav-link-active"
                tile
                depressed
                text
                v-if="!submenu"
              >
                {{ text }}
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="
                      primary--text
                      text-caption text-lg-body-1 text-none
                      px-2 px-lg-3
                      py-5
                    "
                    :class="{ 'ml-lg-2': key > 0 }"
                    active-class="font-weight-bold nav-link-active"
                    tile
                    depressed
                    text
                  >
                    {{ text }}
                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>
                <v-list tile>
                  <v-list-item
                    v-for="(item, index) in submenu"
                    :to="item.to"
                    :key="index"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>

          <v-sheet
            height="100%"
            color="primary"
            class="
              d-flex
              align-center
              mr-n1
              position-relative
              header-desktop-main-social
            "
          >
            <template
              v-for="({ title, link, icon, size }, keySocial) in social"
            >
              <div :key="keySocial" class="d-inline-flex">
                <v-btn
                  small
                  class="secondary primary--text mx-1"
                  :href="link"
                  target="_blank"
                  :title="title"
                  depressed
                  fab
                >
                  <v-icon :size="size">{{ icon }}</v-icon>
                </v-btn>
              </div>
            </template>

            <v-btn
              v-if="informations.whatsapp_float"
              class="text-none ml-1"
              :href="informations.whatsapp_float"
              target="_blank"
              color="white"
              outlined
              depressed
              rounded
            >
              <v-icon color="white" size="18" left> fa-whatsapp </v-icon>
              {{ informations.float_whatsapp_title || "Fale conosco" }}
            </v-btn>
          </v-sheet>
        </v-sheet>
      </v-sheet>
    </v-app-bar>
  </div>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return this.getSocial(this.informations);
    },
  },
  methods: {
    getSocial,
  },
};
</script>

<style lang="scss" scoped>
.header-desktop-main {
  border-bottom: 1px solid var(--v-grey-lighten4) !important;

  .nav-link {
    &:before {
      opacity: 0 !important;
    }
  }

  &-navigation {
    z-index: 9;
  }

  &-social {
    margin-left: 70px;

    &:before {
      content: "";
      border-color: transparent var(--v-primary-base) transparent transparent;
      border-style: solid;
      border-width: 96px 70px 0 96px;
      height: 0px;
      position: absolute;
      right: 100%;
      top: 0;
      width: 0px;
    }

    &:after {
      background-color: var(--v-primary-base);
      bottom: 0;
      content: "";
      left: 100%;
      position: absolute;
      top: 0;
      width: 100vw;
    }
  }
}
</style>
